import { Component, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import { ValidationObserver } from 'vee-validate';
import IssueCommentService from '@/services/issue-comment.service';
import { CommentEntity } from '@/entities/comment.entity';
import BulletinCommentService from '@/services/bulletin-comment.service';

@Component<CommentBoxMixin>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class CommentBoxMixin extends Vue {
  currentStaff!: StaffEntity;

  attachFile: File = null;

  commentData: Partial<CommentEntity>;

  service: IssueCommentService | BulletinCommentService;

  @Ref('form')
  readonly form!: InstanceType<typeof ValidationObserver>;

  async saveComment(): Promise<void> {
    try {
      const comment = await this.service.createOne(this.commentData);
      this.commentData.content = '';
      if (this.attachFile) {
        await this.service.upload(comment.id, { file: this.attachFile });
        this.attachFile = null;
      }
      this.form.reset();
    } catch (e) {
      if (e?.response?.data?.message) {
        await this.$cheeers.notify({
          text: e.response.data.message,
          type: 'error',
        });
      }
    }
  }
}
